module.exports = __webpack_public_path__ + "static/scale-model-of-pumpjacks-mural-in-midland-texas-a5d29b8337a0c369bd238b0e9d0580c3.png";